/**
 * @generated SignedSource<<5723acbc215150214dc56d3349090f0d>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type HeaderIssueTitle$data = {
  readonly number: number;
  readonly repository: {
    readonly nameWithOwner: string;
  };
  readonly title: string;
  readonly titleHTML: string;
  readonly " $fragmentType": "HeaderIssueTitle";
};
export type HeaderIssueTitle$key = {
  readonly " $data"?: HeaderIssueTitle$data;
  readonly " $fragmentSpreads": FragmentRefs<"HeaderIssueTitle">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "HeaderIssueTitle",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "title",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "titleHTML",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "number",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Repository",
      "kind": "LinkedField",
      "name": "repository",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "nameWithOwner",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Issue",
  "abstractKey": null
};

(node as any).hash = "9a45a01c61831e34d04cdca208e64817";

export default node;
